import Game from './Game.js';

const gameContainer = document.getElementById('game-container');
new Game(gameContainer);
